<template>
  <v-dialog v-model="dialog" persistent max-width="300">
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip v-if="!isDelete" bottom :color="$vuetify.theme.themes.light.tooltipColor">
        <template v-slot:activator="{ on: tooltip, attrs }">
          <img
            v-bind="attrs"
            v-on="{ ...tooltip, ...dialog }"
            class="remove-icon"
            src="@/assets/images/Remove.svg" />
        </template>
        <span>Delete</span>
      </v-tooltip>
      <v-tooltip v-else bottom :color="$vuetify.theme.themes.light.tooltipColor">
        <template v-slot:activator="{ on: tooltip, attrs }">
          <img
            v-bind="attrs"
            height="28"
            width="28"
            v-on="{ ...tooltip, ...dialog }"
            class="remove-icon"
            src="@/assets/images/Restore.svg" />
        </template>
        <span>Restore</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title class="card-title">Delete Request</v-card-title>
      <v-card-text>
        Are you sure want to
        <strong>{{ isDelete ? "RESTORE" : " DELETE"}}</strong> record?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="disAgree">Disagree</v-btn>
        <v-btn color="green darken-1" text @click="agree">Agree</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { UserService } from "@/services";

export default {
  name: "DeleteUser",
  data() {
    return {
      dialog: false,
    };
  },
  props: {
    id: String,
    isDelete: Boolean,
  },
  methods: {
    async agree() {
      this.dialog = false;
      this.$emit("isLoading");
      try {
        const userObj = {
          isDelete: this.isDelete ? false : true,
        };
        const response = await UserService.updateUser({
          id: this.id,
          object: userObj,
        });
        if (response) {
          this.$emit("requestDeleted");
          if (!this.isDelete) {
            this.$store.dispatch("user/setSnack", "User deleted successfully!");
          } else {
            this.$store.dispatch(
              "user/setSnack",
              "User restored successfully!"
            );
          }
          this.$store.dispatch("user/setType", "info");
        }
      } catch (error) {
        this.$store.dispatch("user/setSnack", error);
        this.$store.dispatch("user/setType", "error");
      }
    },
    disAgree() {
      this.dialog = false;
    },
  },
};
</script>
